import { render, staticRenderFns } from "./Col3.vue?vue&type=template&id=071fa2b6&"
import script from "./Col3.vue?vue&type=script&lang=js&"
export * from "./Col3.vue?vue&type=script&lang=js&"
import style0 from "./Col3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports